import { useEffect } from 'react';

const usePostHeight = () => {

  useEffect(() => {
    const sendHeight = () => {
      const height = document.documentElement.scrollHeight;
      window.parent.postMessage(
        { type: 'resize', height },
        'https://www.finaldebtrelief.com'
      );
    };

    // Initial send
    sendHeight();

    // Send on resize
    window.addEventListener('resize', sendHeight);

    // Set up a MutationObserver to detect DOM changes
    const observer = new MutationObserver(() => {
      sendHeight();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    // Cleanup
    return () => {
      window.removeEventListener('resize', sendHeight);
      observer.disconnect();
    };
    // eslint-disable-next-line
  }, []);
};

export default usePostHeight;
